// libs
import React from 'react';

import Platform from '@lyearn/core/utils/Platform';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, Button } from '@lyearn/ui';
// components
import { Footer } from '@/components/DialogComponent';

// types
import { ActionType } from '../../../types';
import { footerButtonStyles } from './styles';

const DEFAULT_CLASSNAME =
  'flex flex-row items-center w-full sticky bottom-0 z-50 px-24 pt-20 pb-20 flex-shrink-0 native:px-16 native:pb-36 native:pt-24 native:flex-1';

function DialogFooter(props: { showCloseBtn: boolean; action: ActionType; onClose: () => void }) {
  const { t } = useTranslation();
  const { showCloseBtn = true, action, onClose } = props;
  const {
    className,
    onSubmit,
    onSecondarySubmit,
    text,
    discardText,
    disabled = false,
    appearance = 'primary',
    isSubmitting = false,
    isSubmittingSecondary = false,
    secondaryVariant = 'outlined',
    endIcon,
    classes,
    TertiaryAction,
    buttonSize,
  } = action;
  const isNative = Platform.OS !== 'web';

  return (
    <Footer
      className={cn(
        DEFAULT_CLASSNAME,
        className,
        TertiaryAction ? 'justify-between' : 'justify-end',
      )}>
      {TertiaryAction}
      <Box className={cn(classes?.buttonContainer, 'flex-row')}>
        {showCloseBtn ? (
          <Button
            appearance="secondary"
            className={cn(
              'native:px-0 bg-bg-primary me-8 xs:flex-1',
              classes?.discard,
              TertiaryAction ? footerButtonStyles : '',
            )}
            loading={isSubmittingSecondary}
            shape="pill"
            size={buttonSize || (isNative ? 'large' : 'medium')}
            variant={secondaryVariant}
            onClick={onSecondarySubmit || onClose}>
            {discardText ?? t('Common:Cancel')}
          </Button>
        ) : null}
        <Button
          appearance={appearance}
          className={cn(
            'native:px-0 xs:flex-1',
            classes?.action,
            TertiaryAction ? footerButtonStyles : '',
          )}
          disabled={disabled}
          endIcon={endIcon}
          loading={isSubmitting}
          shape="pill"
          size={buttonSize || (isNative ? 'large' : 'medium')}
          onClick={onSubmit}>
          {text ?? t('Common:Actions.Confirm')}
        </Button>
      </Box>
    </Footer>
  );
}

export default DialogFooter;
